import { MenuItem } from "@blueprintjs/core";
import _ from "lodash";
import React from "react";
import {
  Lang,
  LangSetting,
  LanguageDefault,
  Languages,
  LanguageSetting_Key,
} from "../lang/lang";
import { usePersistedState } from "../utils/state";

export const LanguageSelector = () => {
  const { setState: setLanguage, state: language } = usePersistedState<
    LangSetting
  >(LanguageSetting_Key, { lang: LanguageDefault });

  return (
    <MenuItem text={Languages[language.lang].global.langSelector.language}>
      {_(Lang)
        .values()
        .map((lang) => (
          <MenuItem
            text={Languages[language.lang].langs[lang]}
            key={lang.toString()}
            icon={language.lang === lang ? "confirm" : "select"}
            onClick={() => {
              setLanguage({ lang });
              window.location.reload();
            }}
          ></MenuItem>
        ))
        .value()}
    </MenuItem>
  );
};
